import React, {useContext, useEffect, useMemo} from 'react'

import useDispatchAction from '@hooks/useDispatchAction'
import {getMyTaskList} from 'redux/Slices/AppSlice/Profile/Profile.slice'
import {safeParseInt} from 'utils/ConstFunctions'
import {AuthContext} from 'context/AuthContext'
import {useParams, useLocation} from 'react-router-dom'
import AssessmentView from './AssessmentView'
import Overview from 'screens/Patients/LeadsProfile/main/overview/Overview'
import OverviewBraces from 'screens/Patients/LeadsProfile/main/overview/OverviewBraces'
import useAllUserPlan from '@hooks/useAllUserPlan'
import {useSelector} from 'react-redux'
import {RootState} from 'redux/store'
import treatmentTypeMain from '@constants/treatmentTypeMain'
import StarterPlanOverview from 'screens/PatientDetailsOverview.tsx/tabs/StarterPlanOverview'
import {useTreatmentPlanFilter} from '@hooks/useTreatmentPlanFilter'

export type TaskShape = {
  my_task_id: number
  patient_id: number
  added_by_profile_id: number
  title: string
  description?: string | null
  assignee_name: string
  assignee_profile_id: number
  due_date: string
  status: 'PENDING' | 'COMPLETED'
  priority: 'HIGH' | 'MEDIUM' | 'LOW'
}

const MyTasks: React.FC = () => {
  const {dispatchAction} = useDispatchAction()
  const {userId, profileId} = useContext(AuthContext)
  const {patientId} = useParams()
  const location = useLocation()
  const {isStarterPlanUser} = useAllUserPlan()
  const {data} = useSelector((state: RootState) => state.apiGetLeadsProfileDetails)
  const productType = data?.getting_started_details?.product_type
  const {dataLeadsOverview: dataLeadsData} = useSelector((state: RootState) => state.leadsProfile)
  const {selectedTreatmentPlanId} = useSelector(
    (state: RootState) => state.leadsProfileTreatmentPlanReducer
  )
  
  // FIX: Get order_id from URL for StarterPlanOverview
  const urlOrderId = new URLSearchParams(location.search).get('order_id')

  useEffect(() => {
    const parsedDoctorId = safeParseInt(userId)
    const parsedPatientId = safeParseInt(patientId)
    const parsedProfileId = safeParseInt(profileId)

    if (!parsedDoctorId || !parsedPatientId || !parsedProfileId) return

    dispatchAction(
      getMyTaskList({
        doctor_id: parsedDoctorId,
        patient_id: parsedPatientId,
        filter: 'PENDING',
        order: 'ASC',
        assignee_profile_id: parsedProfileId,
        profile_id: parsedProfileId,
        my_task_type: 'MY_TASK',
      })
    )
  }, [dispatchAction, userId, patientId, profileId])

  const tracking_enabled = dataLeadsData?.tracking?.enabled

  if (isStarterPlanUser) {
    if (productType === treatmentTypeMain.BRACES) {
      return <OverviewBraces />
    } else {
      if (!tracking_enabled) {
        return <Overview />
      } else {
        // FIX: Pass both treatmentPlanId and orderId to StarterPlanOverview
        return (
          <StarterPlanOverview 
            treatmentPlanId={selectedTreatmentPlanId}
            key={`${selectedTreatmentPlanId}-${urlOrderId}-${patientId}`} // Force re-render when patient, plan, or order changes
          />
        )
      }
    }
  }

  return <AssessmentView />
}

export default MyTasks